import React from 'react';
import { useAdminStore } from './adminStore';
import { effectiveState } from './selectors';
export { useGuardedAction } from './useGuardedAction';

/**
 * FeatureGate wrapper component.
 * Conditionally renders children if the feature is enabled.
 * If disabled, renders optional fallback or null.
 */
export function FeatureGate({ id, fallback = null, children }) {
  const store = useAdminStore();
  const state = effectiveState(id, store);
  if (!state.enabled) {
    return fallback;
  }
  return <>{children}</>;
}

/**
 * Hook to check if a writable action should be enabled or disabled with tooltip.
 * Usage: const { disabled, reason } = useFeatureAccess('simulate_punch');
 */
export function useFeatureAccess(featureId) {
  const store = useAdminStore();
  const state = effectiveState(featureId, store);

  return {
    disabled: state.isActionBlocked,
    reason: state.blockReason,
    state
  };
}
